import styled from "styled-components";

export const StyledHome = styled.div`
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-around;
`
